// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"_1O3ZT70rLCbXkedLYnL8mh","pageBreak":"_3h8bAF5ypAgOVwMBL_XyTe","hidden":"_3RwdU5ufVCMOGShXvuZK-z"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/patientPages/print/printPatientPage.scss
// module id = 468
// module chunks = 0